import { SimpleShowLayout } from "react-admin";
import SessionExamStudent from "./SessionExamStudent";
import { SectionTitle } from "features/SectionTitle";

const SessionExamStudentInfo = ({ record }) => {
  return (
    <>
      <SectionTitle
        title="Студентска информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>{record && <SessionExamStudent record={record} />}</SimpleShowLayout>
    </>
  );
};

export default SessionExamStudentInfo;
